import CustomButton from 'components/Buttons/CustomButton'
import { Archive, RotateCcw, AlertCircle } from 'react-feather'
import { Modal, ModalBody, Spinner } from 'reactstrap'
import colors from 'Theme/colors'

const ModalArchiveTransaction = ({
  isOpen,
  toggle,
  handleConfirm,
  isLoading,
  errMsg,
  isArchive = true,
  count = 1,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      autoFocus={false}
      style={{ maxWidth: '420px' }}
      data-testid="modal-archive-transaction"
    >
      <ModalBody className="p-4">
        <div className="d-flex flex-column align-items-center text-center">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center mb-3"
            style={{
              width: '56px',
              height: '56px',
              backgroundColor: isArchive ? '#F0F9FF' : '#F2F4F7',
              color: isArchive ? colors.primary[600] || '#005370' : '#344054',
              border: `8px solid ${isArchive ? '#E0F2FE' : '#EAECF0'}`,
            }}
          >
            {isArchive ? <Archive size={24} /> : <RotateCcw size={24} />}
          </div>

          <h5 className="fw-bold text-dark mb-2">
            {isArchive ? 'Arsipkan Transaksi' : 'Batalkan Arsip Transaksi'}
          </h5>

          <p className="text-muted small mb-3" style={{ lineHeight: '1.5' }}>
            {isArchive
              ? `Apakah Anda yakin ingin mengarsipkan ${
                  count > 1 ? `${count} transaksi yang dipilih` : 'transaksi ini'
                }? Transaksi yang diarsipkan akan dipindahkan ke daftar transaksi diarsipkan.`
              : `Apakah Anda yakin ingin mengembalikan ${
                  count > 1 ? `${count} transaksi yang dipilih` : 'transaksi ini'
                } ke daftar transaksi aktif?`}
          </p>

          {errMsg && (
            <div className="w-100 p-2 mb-3 bg-danger-50 text-danger rounded small d-flex align-items-center gap-2">
              <AlertCircle size={16} />
              <span>{errMsg}</span>
            </div>
          )}

          <div className="d-flex gap-2 w-100 mt-2">
            <CustomButton
              color="secondary"
              outline
              onClick={toggle}
              block
              size="md"
              disabled={isLoading}
              testId="modal-archive-cancel-button"
            >
              Batal
            </CustomButton>
            <CustomButton
              color="primary"
              onClick={handleConfirm}
              block
              size="md"
              disabled={isLoading}
              testId="modal-archive-confirm-button"
            >
              {isLoading ? (
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <Spinner size="sm" />
                  <span>Memproses...</span>
                </div>
              ) : isArchive ? (
                'Ya, Arsipkan'
              ) : (
                'Ya, Kembalikan'
              )}
            </CustomButton>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalArchiveTransaction
